<template>
  <div>
    <EventMain/>
  </div>
</template>

<script>
import EventMain from '@/components/EventMain'

export default {
  components: {
    EventMain
  }
}
</script>
